import { CalendarClock, RefreshCcw, PiggyBank, PackageCheck } from "lucide-react";
import { Reveal } from "./Reveal";

const PERKS = [
  { icon: CalendarClock, text: "£14.99 per month — a fresh 60-patch pack delivered regularly" },
  { icon: PackageCheck, text: "Never run out mid-routine — your ritual arrives at your door" },
  { icon: PiggyBank, text: "Save 25% compared with the £19.99 one-time price" },
  { icon: RefreshCcw, text: "Easy to manage — cancel in line with our subscription terms" },
];

export const Subscription = () => {
  return (
    <section id="subscribe" className="py-24 md:py-32 relative overflow-hidden" data-testid="subscription-section">
      <div className="pointer-events-none absolute -bottom-40 -left-40 w-[480px] h-[480px] rounded-full bg-champagne/70 blur-3xl" />
      <div className="relative max-w-2xl mx-auto px-5 sm:px-8">
        <div>
          <Reveal>
            <p className="text-xs font-semibold tracking-[0.3em] uppercase text-gold mb-5">Never Run Out</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink">
              Your ritual, <span className="italic gold-text">on repeat</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-md text-base md:text-lg text-[#5C5C5C] leading-relaxed">
              Join Subscribe &amp; Save and receive a fresh pack of 60 gold hydrogel patches every month — one less
              thing to think about.
            </p>
          </Reveal>
          <div className="mt-10 space-y-5">
            {PERKS.map((p, i) => (
              <Reveal key={p.text} delay={0.1 + i * 0.06}>
                <div className="flex items-start gap-4" data-testid={`subscription-perk-${i}`}>
                  <span className="mt-0.5 w-9 h-9 shrink-0 rounded-full bg-white border border-champagne flex items-center justify-center">
                    <p.icon size={16} strokeWidth={1.5} className="text-gold-deep" />
                  </span>
                  <p className="text-[15px] text-[#3d3d3d] leading-relaxed">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
